export var Basis;
(function (Basis) {
    Basis["PerTeu"] = "per_teu";
    Basis["PerFeu"] = "per_feu";
    Basis["PerContainer"] = "per_container";
    Basis["PerBl"] = "per_bl";
    Basis["PerEbl"] = "per_ebl";
})(Basis || (Basis = {}));
export var ChargeApplication;
(function (ChargeApplication) {
    ChargeApplication["Origin"] = "origin";
    ChargeApplication["Destination"] = "destination";
    ChargeApplication["Freight"] = "freight";
})(ChargeApplication || (ChargeApplication = {}));
export var LocationType;
(function (LocationType) {
    LocationType["Port"] = "Port";
    LocationType["Airport"] = "Airport";
    LocationType["Door"] = "Door";
})(LocationType || (LocationType = {}));
export var RateChargeType;
(function (RateChargeType) {
    RateChargeType["Freight"] = "freight";
    RateChargeType["Surcharge"] = "surcharge";
    RateChargeType["Addon"] = "addon";
})(RateChargeType || (RateChargeType = {}));
